'use strict';
import * as $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6 from "./internal-3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.js";
import * as $j_presto$002e$002dList$002dPolicies$002dPage$0024 from "./presto.-List-Policies-Page$.js";
import * as $j_presto$002e$002dPresto$002dRouter$0024$0024anon$002479 from "./presto.-Presto-Router$$anon$79.js";
var $p;
/** @constructor */
function $c_Lpresto_PrestoRouter$$anon$78() {
  this.boi = null;
  this.boa = null;
  this.bob = false;
  this.boj = null;
  this.bok = false;
  this.bon = null;
  this.bog = null;
  this.boh = false;
  this.boc = null;
  this.bod = false;
  this.boe = null;
  this.bof = false;
  this.bol = false;
  this.bom = false;
  this.boi = $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$m_Lio_circe_derivation_Configuration$().u;
  this.bon = "ListPoliciesPage";
}
export { $c_Lpresto_PrestoRouter$$anon$78 as $c_Lpresto_PrestoRouter$$anon$78 };
$p = $c_Lpresto_PrestoRouter$$anon$78.prototype = new $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$h_O();
$p.constructor = $c_Lpresto_PrestoRouter$$anon$78;
/** @constructor */
function $h_Lpresto_PrestoRouter$$anon$78() {
}
export { $h_Lpresto_PrestoRouter$$anon$78 as $h_Lpresto_PrestoRouter$$anon$78 };
$h_Lpresto_PrestoRouter$$anon$78.prototype = $p;
$p.F = (function(c) {
  return $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$f_Lio_circe_Decoder__tryDecode__Lio_circe_ACursor__s_util_Either(this, c);
});
$p.K = (function() {
  return this.boi;
});
$p.M = (function() {
  if ((!this.bob)) {
    this.boa = $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$f_Lio_circe_derivation_ConfiguredDecoder__constructorNames__sci_List(this);
    this.bob = true;
  }
  return this.boa;
});
$p.O = (function() {
  if ((!this.bok)) {
    this.boj = $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$f_Lio_circe_derivation_ConfiguredDecoder__io$circe$derivation$ConfiguredDecoder$$decodersDict__sci_Map(this);
    this.bok = true;
  }
  return this.boj;
});
$p.D = (function() {
  return this.bon;
});
$p.t = (function() {
  if ((!this.boh)) {
    this.bog = $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$m_sci_Nil$();
    this.boh = true;
  }
  return this.bog;
});
$p.N = (function() {
  if ((!this.bod)) {
    this.boc = $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$m_sci_Nil$();
    this.bod = true;
  }
  return this.boc;
});
$p.Q = (function() {
  if ((!this.bof)) {
    this.boe = new $j_presto$002e$002dPresto$002dRouter$0024$0024anon$002479.$c_Lpresto_PrestoRouter$$anon$79();
    this.bof = true;
  }
  return this.boe;
});
$p.v = (function() {
  if ((!this.bom)) {
    this.bol = false;
    this.bom = true;
  }
  return this.bol;
});
$p.G = (function(c) {
  return $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$f_Lio_circe_derivation_ConfiguredDecoder__decodeProduct__Lio_circe_HCursor__F1__s_util_Either(this, c, new $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$c_sjsr_AnonFunction1(((\u03b4scrutinee528) => ((p) => \u03b4scrutinee528))($j_presto$002e$002dList$002dPolicies$002dPage$0024.$m_Lpresto_ListPoliciesPage$())));
});
var $d_Lpresto_PrestoRouter$$anon$78 = new $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$TypeData().i($c_Lpresto_PrestoRouter$$anon$78, "presto.PrestoRouter$$anon$78", ({
  OU: 1,
  a: 1,
  f: 1,
  h: 1,
  d: 1
}));
export { $d_Lpresto_PrestoRouter$$anon$78 as $d_Lpresto_PrestoRouter$$anon$78 };
//# sourceMappingURL=presto.-Presto-Router$$anon$78.js.map
